import React from 'react';
import {useForm, useFormState} from 'react-final-form';
import {compose} from 'recompose';
import block from 'bem-cn-lite';

import ComputeFormFields, {
    ComputeFormFieldsProps,
    ComputeFormFieldsValues,
} from 'components/calculator/ComputeFormFields/ComputeFormFields';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import {getInitialComputeValues} from 'components/calculator/ComputeFormFields/utils';
import CalculatorForm from 'components/calculator/CalculatorForm/CalculatorForm';
import {CalculatorProps, ComputeConfig} from 'components/calculator/models';
import withData from 'components/calculator/withData';
import {getConfig} from 'units/calculator/api';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

const b = block('ComputeFormFields');

type ComputeFormOwnProps = CalculatorProps & Pick<ComputeFormFieldsProps, 'customOsProductId'>;

interface ComputeFormDataProps {
    data: ComputeConfig;
}

type ComputeFormProps = ComputeFormDataProps & ComputeFormOwnProps & WithTranslationProps;

const ComputeForm: React.FC<ComputeFormProps> = (props) => {
    const {
        data: {osProducts, platforms},
        customOsProductId,
        title,
        data,
        i18n,
    } = props;

    const {initialize} = useForm<ComputeFormFieldsValues>();
    const {initialValues, values} = useFormState<ComputeFormFieldsValues>();

    React.useEffect(() => {
        initialize(getInitialComputeValues(data, i18n));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!initialValues) {
        return null;
    }

    return (
        <CalculatorForm title={title} className={b()}>
            <CalculatorFormLayout>
                <ComputeFormFields
                    values={values}
                    platforms={platforms}
                    osProducts={osProducts}
                    customOsProductId={customOsProductId}
                />
            </CalculatorFormLayout>
        </CalculatorForm>
    );
};

const formDataLoader = async (props: ComputeFormProps) => {
    const {locale, customOsProductId} = props;
    return getConfig(locale, 'compute', customOsProductId);
};

export default compose<ComputeFormProps, ComputeFormOwnProps>(
    withData({loader: formDataLoader}),
    withTranslation('calculator'),
)(ComputeForm);
